import {
    OPERATOR_APPLICATION_BRANDS,
    OperatorApplicationBrandInterface
} from "~/operatorApplication/ts/data/OperatorApplicationBrands";
import {computed, ref} from "vue";


class OperatorConfig {
    brandId = ref("talk-me");
    readonly brand = computed<OperatorApplicationBrandInterface>(() => {
        return OPERATOR_APPLICATION_BRANDS[this.brandId.value];
    });
    readonly faviconSrc = computed(() => {
        return `assets/operatorApplication/images/brands/${this.brandId.value}/favicon.ico`;
    });
    readonly assetsPath = computed(() => {
        return "assets/operatorApplication";
    });
    readonly isProduction = computed<boolean>(() => {
        return CORE_UI_PRODUCTION;
    });

    SET_BRAND_ID(brandId: string) {
        this.brandId.value = brandId;
    }
}

export const OperatorConfigStore = new OperatorConfig();